export default {
    add: 'Crear',
    read: 'Leer',
    edit: 'Editar',
    remove: 'Eliminar'
};
